import {SlDialog} from '../../../../vendor/plugins/clxFrontendCms/public/js/shoelace/shoelace';

export class TarifDetailDialogTrigger {
    private readonly viewRoot: HTMLElement;
    private readonly openPriceDetails: HTMLElement | null;

    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;
        this.openPriceDetails = viewRoot.querySelector('.open-price-details');

        this.init();
    }

    private init() {
        if (!this.openPriceDetails) {
            return;
        }

        this.openPriceDetails.addEventListener('click', (event) => {
            event.preventDefault();
            const priceDetailsLayer = this.viewRoot.querySelector('.vt-price-details-layer') as SlDialog | null;
            priceDetailsLayer?.show();
        });
    }
}
